import React, { useContext, useEffect, useRef, useState } from "react";
import Applayout from "../layout/applayout";
import AuthContext from "../../context/AuthContext";
import './fileUploader.css';
import axiosClient from "../../axios/axiosClient";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

function EditProfile() {
  const { user } = useContext(AuthContext);
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [stat, setStat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(JSON.parse(localStorage.getItem('user')));
  const [passFormData, setPassFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handlePassInputChange = (e) => {
    const { name, value } = e.target;
    setPassFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if(file){
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData((prevState) => ({
              ...prevState,
              ["photo"]: reader.result
            }));
        };
        reader.readAsDataURL(file); 

        setFile(event.target.files[0]);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      const file = event.dataTransfer.files[0];
      if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setFormData((prevState) => ({
                ...prevState,
                ["photo"]: reader.result
              }));
          };
          reader.readAsDataURL(file);  // Convert to Base64
      }
     
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    axiosClient.put(`/user/profile`, formData)
        .then((response) => {
            localStorage.setItem('user',JSON.stringify(response.data.data));
            toast.success(response.data.message);
            setLoading(false)
        })
        .catch((error) => {
            setLoading(false)
            toast.error(error.response.data.message);
        });
  };

  const handleSubmitPasswordUpdate = (e) => {
    e.preventDefault()
    setLoading(true)
    let payload = {
        'old_password' : passFormData.oldPassword,
        'new_password' : passFormData.newPassword,
        'new_password_confirmation' : passFormData.confirmPassword,
    }
    axiosClient.post(`/user/update-password`, payload)
        .then((response) => {
            localStorage.setItem('user',JSON.stringify(response.data.data));
            toast.success(response.data.message);
            setPassFormData({
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
            })
            setLoading(false)
        })
        .catch((error) => {
            setLoading(false)
            toast.error(error.response.data.message);
        });
  };

  const getStats = () => {
    setLoading(true)
    axiosClient.get(`/stats`)
        .then((response) => {
            setStat(response.data.data)
            console.log(response.data.data)
            setLoading(false)
        })
        .catch((error) => {
            setLoading(false)
            toast.error(error.response.data.message);
        });
  };

  useEffect(() => {
    getStats()
  }, []);
  return (
    <>
      <Applayout>
        <div className="page-body">
          <div className="container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <div className="page-header-left">
                    <h3>Profile</h3>
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i data-feather="home"></i>
                        </Link>
                      </li>
                      <li className="breadcrumb-item">Users</li>
                      <li className="breadcrumb-item active">Edit Profile</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="edit-profile">
              <div className="row">
                <div className="col-xl-4">
                  <div className="card custom-card">
                    <div className="card-header">
                      <img
                        className="img-fluid"
                        src="../assets/images/user-card/3.jpg"
                        alt=""
                      />
                    </div>
                    <div className="card-profile">
                      <img
                        className="rounded-circle"
                        src={user.photo || "../assets/images/avtar/user.jpeg"}
                        alt=""
                      />
                    </div>
                    <ul className="card-social">
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-google-plus"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="general-widget.html#">
                          <i className="fa fa-rss"></i>
                        </a>
                      </li>
                    </ul>
                    <div className="text-center profile-details">
                      <h4>{user.first_name}</h4>
                      <h6>{user.user_type.replace(/_/g, " ")}</h6>
                    </div>
                    <div className="card-footer row">
                      { stat && stat.map((st) => {
                        return (<div className="col-4 col-sm-4">
                        <h6>{Object.keys(st)}</h6>
                        <h3>
                          <span className="counter">{Object.values(st)}</span>
                        </h3>
                      </div>)})
                      }
                    </div>
                  </div>
                </div>
                <div className="col-xl-8">
                  <form className="card" onSubmit={handleSubmit}>
                    <div className="card-header">
                      <h4 className="card-title mb-0">Edit Profile</h4>
                      <div className="card-options">
                        <a
                          className="card-options-collapse"
                          href="edit-profile.html#"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                        <a
                          className="card-options-remove"
                          href="edit-profile.html#"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x"></i>
                        </a>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-12">
                              <div className="mb-3">
                                <label className="form-label">First Name</label>
                                <input
                                  className="form-control"
                                  type="text"
                                    name="first_name"
                                  placeholder="First Name"
                                  value={formData.first_name}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12">
                              <div className="mb-3">
                                <label className="form-label">Last Name</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="last_name"
                                  placeholder="Last Name"
                                  value={formData.last_name}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Email address
                                </label>
                                <input
                                  className="form-control"
                                  type="email"
                                  name="email"
                                  placeholder="Email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Phone Number
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="phone"
                                  placeholder="Phone"
                                  value={formData.phone}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                            
                          </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="mb-3">
                                <label className="form-label">Gender</label>
                                <select
                                  className="form-select btn-square"
                                   name="gender"
                                  value={formData.gender}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">--Select Gender--</option>
                                  <option value="male">Male</option>
                                  <option value="female">Female</option>
                                  <option value="others">Others</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12">
                                <div className="file-uploader" style={{width:'100%'}}>
                                    <div
                                        className="upload-area"
                                        onClick={handleClick}
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        {file ? (
                                        <p>{file.name}</p>
                                        ) : (
                                        <p style={{fontSize:"9px"}}>Drag & drop a file here or click to upload</p>
                                        )}
                                    </div>

                                    {/* Hidden input */}
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        onChange={handleFileSelect}
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </div>
                            {/*  */}
                      
                            </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer text-end">
                      <button className="btn btn-primary" type="submit">
                        Update Profile
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-md-12">
                  <form className="" onSubmit={handleSubmitPasswordUpdate}>
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Update Password</h4>
                      <div className="card-options">
                        <a
                          className="card-options-collapse"
                          href="edit-profile.html#"
                          data-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                        <a
                          className="card-options-remove"
                          href="edit-profile.html#"
                          data-toggle="card-remove"
                        >
                          <i className="fe fe-x"></i>
                        </a>
                      </div>
                    </div>
                   
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                    <label htmlFor="oldPassword">Old Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="oldPassword"
                                        name="oldPassword"
                                        value={passFormData.oldPassword}
                                        onChange={handlePassInputChange}
                                        required
                                    />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                    <label htmlFor="newPassword">New Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="newPassword"
                                        name="newPassword"
                                        value={passFormData.newPassword}
                                        onChange={handlePassInputChange}
                                        required
                                    />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="confirmPassword">Confirm Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            value={passFormData.confirmPassword}
                                            onChange={handlePassInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-end">
                            <button className="btn btn-primary" type="submit">
                                Update Password
                            </button>
                        </div>
                  </div>
                    </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Applayout>
    </>
  );
}

export default EditProfile;
